import clsx from 'clsx';

export const YOUTUBE_URL = 'youtube.com';

export enum BlockTypes {
  Image = 'image',
  Section = 'section',
  TextContainer = 'textContainer',
  Video = 'video',
}

// Tuning Values from NLCMS Editor
export const CENTER = 'center';
export const alignmentValues = {
  center: 'text-center',
  left: 'text-left',
  right: 'text-right',
};

export const backgroundColorValues = {
  black: 'bg-black',
  charcoal: 'bg-grayscale-charcoal',
  primary: 'bg-primary-magenta',
  secondary: 'bg-primary-pink',
  transparent: 'bg-transparent',
  white: 'bg-white',
};

export const fontSizeValues = {
  small: 'text-body-md',
  normal: 'text-body-lg',
  large: 'text-headline-xxs',
  extraLarge: 'text-headline-xs',
};

export const fontFamilyValues = {
  meta: 'font-meta-normal',
  metaBold: 'font-meta-bold',
  notoSerif: 'font-noto-serif',
  suisseIntl: 'font-suisse-intl',
  suisseIntlMono: 'font-suisse-intl-mono',
  suisseScreen: 'font-suisse-screen',
  suisseWorks: 'font-suisse-works',
};

export const marginValues = {
  small: 'my-8',
  normal: 'my-16',
  large: 'my-24',
  extraLarge: 'my-32',
};

export const paddingValues = {
  small: 'py-8',
  normal: 'py-16',
  large: 'py-24',
  extraLarge: 'py-32',
};

export const isFlex = (value: string) => ['row', 'column'].includes(value);

const gapValues = 'gap-16 sm:gap-24 md:gap-32';
export const gridValues = {
  row: clsx('flex flex-row', gapValues),
  column: clsx('flex flex-col', gapValues),
  grid: clsx('grid', gapValues),
  'grid-3': clsx('grid grid-cols-2 sm:grid-cols-3', gapValues),
  'grid-4': clsx('grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4', gapValues),
};

export const preloadValues = {
  auto: 'auto',
  metadata: 'metadata',
  none: 'none',
};

export const verticalAlignmentValues = {
  bottom: 'items-bottom',
  center: 'items-middle',
  stretch: 'items-stretch',
  top: 'items-top',
};

export const widthValues = {
  auto: 'auto',
  '25': '25%',
  '50': '50%',
  '75': '75%',
  '100': '100%',
};
